import { render } from "./AvailableQuestionnaires.vue?vue&type=template&id=2a94d720"
import script from "./AvailableQuestionnaires.vue?vue&type=script&lang=js"
export * from "./AvailableQuestionnaires.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__